import Vue from 'vue';
import VueAnalytics from 'vue-analytics';
import VueMasonry from 'vue-masonry-css';

import moment from 'moment';
import 'moment/locale/pt-br';

import { Alert } from '../services/alert';

/**
 * DO NOT USE
 *
 * @todo remove moment and packages that dependes on it
 */
moment.locale(BulldeskSettings.locale === 'en' ? 'en' : 'pt-br');
window.moment = moment;

window.Vue = Vue;

require('vue-resource');

const ToggleButton = require('vue-js-toggle-button').default;

Vue.use(ToggleButton);

/*
 * Bus
 */
window.Bus = new Vue();

/*
 * Load Lodash, used for map / reduce on arrays.
 */
window._ = require('lodash');

window.Popper = require('popper.js/dist/umd/popper');

window.Alert = Alert;
window.ClipboardJS = require('clipboard');

/**
 * Set CSRF token on ajax requests (jQuery and Vue).
 */
const csrf = document.querySelector('#csrf-token');

if (csrf) {
  Vue.http.headers.common['X-CSRF-TOKEN'] = csrf.getAttribute('content');
}

/**
 * Load Vue HTTP Interceptors.
 */
Vue.http.interceptors.push(require('../services/interceptors'));

Vue.use(require('vue-stash').default);

Vue.use(VueMasonry, {
  name: 'Masonry',
});

Vue.use(VueAnalytics, {
  id: ['UA-65677980-5'],
});
